import baseApi from './base';

// 系统配置-修改系统配置
const updateSystemConfig = (id, data) =>
  baseApi.request({
    method: 'PATCH',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `/system-config/${id}`,
    data
  });

// 系统配置-获取系统配置
const getSystemConfig = () =>
baseApi.request({
  method: 'get',
  url: '/system-config',
});

export {
  getSystemConfig,
  updateSystemConfig,
};



// WEBPACK FOOTER //
// ./src/api/system.js